export const maskEmail = (email) => {
    if (!email) {
      return '';
    }
    const [username, domain] = email?.split('@');
    
    if (username.length > 4) {
      return `${username.slice(0, 4)}***@${domain}`;
    } else {
      return `${username.slice(0, 2)}***@${domain}`;
    }
}
